<div *ngIf='!hasSkins()' style='width:100%;height:500px' fxLayout='column' fxLayoutAlign='center center'>
  <div>
    Loading
  </div>
  <div>
    <i class='fa fa-spinner fa-spin'></i>
  </div>

</div>

<div *ngIf='hasSkins()' fxLayout="column" fxLayoutAlign="start stretch">
  <s18-event-summary *ngIf='eventInfo' [eventInfo]='eventInfo'></s18-event-summary>
  <div fxFlexLayout='row wrap' fxLayoutAlign='center'>
    <s18-display-skins *ngIf='!hasFlightedSkins()' [skins]='skins'></s18-display-skins>
    <mat-card *ngFor='let eventSkin of multiRoundSkins'>
      <mat-card-title>{{eventSkin.name}}</mat-card-title>
      <s18-display-skins *ngIf='multiRoundSkins.length>0' [skins]='eventSkin'></s18-display-skins>
    </mat-card>
  </div>
  <div *ngIf='hasFlightedSkins()' fxLayout='row wrap' fxLayout.xs='column' fxLayoutAlign='center'>
    <mat-card *ngFor='let flightedSkin of skins.skins'>
      <mat-card-title>Flight {{getFlightLetter(flightedSkin.flight)}}</mat-card-title>
      <s18-display-skins [skins]='flightedSkin'></s18-display-skins>
    </mat-card>
  </div>
</div>